import { useEffect, useState } from "react";
import { EVENT_START } from "@/config";

const target = new Date(EVENT_START).getTime();

export const useCountdown = () => {
  const [now, setNow] = useState(Date.now());
  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(t);
  }, []);
  const diff = Math.max(0, target - now);
  return {
    live: diff === 0,
    d: Math.floor(diff / 86400000),
    h: Math.floor((diff / 3600000) % 24),
    m: Math.floor((diff / 60000) % 60),
    s: Math.floor((diff / 1000) % 60),
  };
};

const pad = (n) => String(n).padStart(2, "0");

export const Countdown = ({ testId = "countdown", dark = false }) => {
  const { live, d, h, m, s } = useCountdown();
  if (live) {
    return (
      <p data-testid={`${testId}-live`} className="text-center font-bold text-green-600 text-sm">
        We are LIVE now — join from the WhatsApp group
      </p>
    );
  }
  const units = [["Days", d], ["Hours", h], ["Mins", m], ["Secs", s]];
  return (
    <div data-testid={testId} className="flex justify-center gap-2" role="timer" aria-label="Time until masterclass starts">
      {units.map(([label, v]) => (
        <div key={label} className={`min-w-[62px] rounded-xl px-2 py-2 text-center ${dark ? "bg-white/10 text-white" : "bg-ink text-white"}`}>
          <div className="font-black text-xl sm:text-2xl tabular-nums leading-none" data-testid={`${testId}-${label.toLowerCase()}`}>{pad(v)}</div>
          <div className="text-[11px] uppercase tracking-wider text-white/75 mt-1">{label}</div>
        </div>
      ))}
    </div>
  );
};
